import React from 'react'
import {
    Form,
    Input,
    Button,
    Icon,
    Row,
    Col,
    Divider,
    Table,
    DatePicker,
    Select,
    Statistic,
    Tooltip,
    Checkbox,
} from 'antd'
// import debounce from 'lodash/debounce'
import API from '../../../services/API'
import NumberFormat from 'react-number-format'

import {
 Link
} from 'react-router-dom';

const { RangePicker } = DatePicker

// eslint-disable-next-line prefer-destructuring
const Option = Select.Option

// eslint-disable-next-line no-unused-vars
const getRandomId = length => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const charactersLength = characters.length
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
}

class ReportSalesForm extends React.Component {
    constructor(props) {
        super(props)
        let localSubsidiary = JSON.parse(localStorage.getItem('sucursal'))
        if (localSubsidiary) {
            localSubsidiary = localSubsidiary.id
        }

        this.state = {
            loading: false,
            query: '',
            total: 0,
            pagination: {},
            dateRange: {
                startDate: null,
                endDate: null,
            },
            orders: {
                data: [],
                loading: false,
            },
            users: {
                data: [],
                loading: false,
                current: null,
            },
            subsidiaries: {
                data: [],
                loading: false,
                current: null,
            },
            localSubsidiary,
        }
    }

    componentDidMount() {
        this.getSubsidiaries()
        this.getUsers()
        this.getData({
            page: 1,
        })
    }

    getUsers = async () => {
        this.setState({
            users: {
                data: [],
                loading: true,
                current: null,
            },
        })
        await API.get(`/api/users?pagination=false&filter[active]=1`)
            .then(response => {
                this.setState({
                    users: {
                        data: response.data,
                        loading: false,
                        current: null,
                    },
                })
            })
            .catch(err => {
                console.error('Este es el response: ', err)
            })
    }

    getSubsidiaries = async () => {
        this.setState({
            subsidiaries: {
                ...this.state.subsidiaries,
                data: [],
                loading: true,
            },
        })

        await API.get('/api/subsidiaries?pagination=false&filter[active]=1')
            .then(response => {
                const current = !this.state.subsidiaries.current
                    ? this.state.localSubsidiary
                    : this.state.subsidiaries.current
                this.setState({
                    subsidiaries: {
                        data: response.data,
                        loading: false,
                        current,
                    },
                })
            })
            .catch(err => {
                console.error('Este es el response: ', err)
            })
    }

    getData = async ({ page = 1, filters = null, sorter = null }) => {
        let newQuery = `per_page=10&include[]=payments&include[]=customer&include[]=status&include[]=user&is_credit1&page=${page}`
        this.setState({
            orders: {
                data: [],
                loading: true,
            },
            loading: true,
            total: 0,
        })

        if (this.state.dateRange.startDate && this.state.dateRange.endDate) {
            const { dateRange } = this.state
            if (dateRange && dateRange.startDate && dateRange.endDate) {
                if (dateRange.startDate.format('YYYY-MM-DD') === dateRange.endDate.format('YYYY-MM-DD')) {
                    newQuery += `&filter[captured_at]=${dateRange.startDate.format('YYYY-MM-DD')}`
                } else {
                    newQuery += `&dateRange=${dateRange.startDate.format('YYYY-MM-DD')},${dateRange.endDate.format(
                        'YYYY-MM-DD'
                    )}`
                }
            }
        }
        const subsidiariesCurrent = !this.state.subsidiaries.current
            ? this.state.localSubsidiary
            : this.state.subsidiaries.current

        if (subsidiariesCurrent && subsidiariesCurrent != 'all') {
            newQuery += `&filter[subsidiary_id]=${subsidiariesCurrent}`
        }

        if (this.state.users.current && this.state.users.current != 'all') {
            newQuery += `&filter[user_id]=${this.state.users.current}`
        }

        for (let key in filters) {
            newQuery += `&filter[${key}]=${filters[key]}`
        }

        await API.get('/api/orders?' + newQuery)
            .then(response => {
                var url = new URL(response.data.first_page_url)
                var total = url.searchParams.get('total')
                this.setState({
                    orders: {
                        data: response.data.data,
                        loading: false,
                    },
                    pagination: {
                        ...this.state.pagination,
                        total: response.data.total,
                    },
                    loading: false,
                    query: newQuery,
                    total: total,
                })
            })
            .catch(() => {
                this.setState({
                    orders: {
                        ...this.state.orders,
                        loading: false,
                    },
                    loading: false,
                })
            })
    }

    handleSearch = (selectedKeys, confirm, column) => {
        confirm()
    }

    handleReset = clearFilters => {
        this.getData({
            page: 1,
        })
        clearFilters()
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder="Buscar"
                    value={selectedKeys}
                    onChange={e => {
                        setSelectedKeys(e.target.value ? e.target.value : [])
                    }}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Cancelar
                </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
    })

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.orders.pagination }
        pager.current = pagination.current
        this.setState({
            orders: {
                pagination: pager,
            },
            loading: true,
        })
        this.getData({
            page: pagination.current,
            filters,
            sorter,
        })
    }

    dateStart = (date, dateString) => {
        this.setState(
            {
                dateRange: {
                    ...this.state.dateRange,
                    startDate: dateString,
                },
            },
            () => {
                this.redirectGetData()
            }
        )
    }

    dateEnd = (date, dateString) => {
        this.setState(
            {
                dateRange: {
                    ...this.state.dateRange,
                    endDate: dateString,
                },
            },
            () => {
                this.redirectGetData()
            }
        )
    }

    redirectGetData = () => {
        const { pagination } = this.state
        this.getData({
            page: pagination.current,
            filters: null,
            sorter: null,
        })
    }

    generateInvoicePDF = order => () => {
        window.open(`/api/orders/${order.id}/invoice`, '_blank')
    }

    render() {
        const columns = [
            {
                title: 'Id único',
                dataIndex: 'unique_id',
                key: 'unique_id',
                sorter: true,
                ...this.getColumnSearchProps('name'),
            },
            {
                title: 'Cliente',
                key: 'customerName',
                dataIndex: 'customerName',
                sorter: true,
                render: (label, record) => {
                    const rfc = record.customer_id && record.customer.rfc ? `(${record.customer.rfc})` : null
                    const txt = rfc ? rfc : record.customer_email ? `(${record.customer_email})` : ''

                    return (
                        <Link to={`/customers/edit/${record.customer_id}`} style={{color:'black',textDecoration:'underline'}}>
                            <span>
                                {record.customer_id
                                    ? `${record.customer_first_name} ${record.customer_last_name} ${txt}`
                                    : ''}
                            </span>
                        </Link>
                    )
                },
                ...this.getColumnSearchProps('name'),
            },
            {
                title: 'Cajero',
                dataIndex: 'user_first_name',
                key: 'user_first_name',
                sorter: true,
                render: (label, record) => (record.user ? `${record.user.name} ${record.user.last_name}` : ''),
            },
            {
                title: 'Cantidad',
                dataIndex: 'total_item_count',
                key: 'total_item_count',
            },
            {
                title: 'Subtotal',
                dataIndex: 'sub_total',
                key: 'sub_total',
                sorter: true,
                ...this.getColumnSearchProps('name'),
                render: (label, row) => {
                    return (
                        <NumberFormat
                            decimalScale={4}
                            fixedDecimalScale
                            thousandSeparator
                            prefix="$"
                            displayType="text"
                            value={row.sub_total}
                        />
                    )
                },
            },
            {
                title: 'IVA',
                dataIndex: 'tax_amount',
                key: 'tax_amount',
                sorter: false,
                render: (label, row) => {
                    return (
                        <NumberFormat
                            decimalScale={4}
                            fixedDecimalScale
                            thousandSeparator
                            prefix="$"
                            displayType="text"
                            value={row.tax_amount}
                        />
                    )
                },
            },
            {
                title: 'Total',
                dataIndex: 'grand_total',
                key: 'grand_total',
                sorter: false,
                render: (label, row) => {
                    return (
                        <NumberFormat
                            decimalScale={4}
                            fixedDecimalScale
                            thousandSeparator
                            prefix="$"
                            displayType="text"
                            value={row.grand_total}
                        />
                    )
                },
            },
            {
                title: 'Fecha',
                dataIndex: 'captured_at',
                key: 'captured_at',
            },

            {
                title: 'Credito',
                dataIndex: 'is_credit',
                key: 'is_credit',
                filterMultiple: false,
                filters: [{ text: 'Si', value: 1 }, { text: 'No', value: 0 }],
                render: (label, row) => {
                    return row.status ? 'Si' : 'No'
                },
            },
            {
                title: 'Estado',
                dataIndex: 'order_status_id',
                key: 'order_status_id',
                filterMultiple: true,
                filters: [
                    { text: 'En proceso', value: 1 },
                    { text: 'Cancelado', value: 2 },
                    { text: 'Enviado', value: 3 },
                    { text: 'Entregado', value: 4 },
                    { text: 'Facturado', value: 5 },
                ],
                render: (label, row) => {
                    return row.status ? row.status.name : ''
                },
            },
            {
                title: 'Factura',
                dataIndex: 'unique_id',
                key: 'invoice',
                render: (label, row) => {
                    if (row.customer.customer_type_id === 1) return 'No'
                    return (
                        <Button onClick={this.generateInvoicePDF(row)} type="primary" shape="circle" icon="file-pdf" />
                    )
                },
            },
        ]

        return (
            <>
                <Form>
                    <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Col lg={5}>
                            <Statistic title="Venta global" value={this.state.total} precision={2} prefix={'$'} />
                        </Col>

                        <Col lg={2}>
                            <Tooltip title="Generar hoja de calculo" placement="left">
                                <Button
                                    style={{ marginRight: '10px' }}
                                    type="primary"
                                    shape="circle"
                                    icon="download"
                                    onClick={() =>
                                        (window.location.href =
                                            '/api/excel?table=orders&pagination=false&json=false&' + this.state.query)
                                    }
                                />
                            </Tooltip>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col lg={5}>
                            <Form.Item label="Fecha Inicial">
                                <div>
                                    <RangePicker
                                        value={[this.state.dateRange.startDate, this.state.dateRange.endDate]}
                                        onChange={dateRange => {
                                            this.setState({
                                                dateRange: {
                                                    startDate: dateRange[0],
                                                    endDate: dateRange[1],
                                                },
                                            })
                                        }}
                                    />
                                </div>
                            </Form.Item>
                        </Col>
                        <Col lg={5}>
                            <Form.Item label="Sucursal">
                                <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    loading={this.state.subsidiaries.loading}
                                    placeholder="Selecciona una sucursal"
                                    optionFilterProp="children"
                                    value={this.state.subsidiaries.current}
                                    onChange={value => {
                                        this.setState({
                                            subsidiaries: {
                                                ...this.state.subsidiaries,
                                                current: value,
                                            },
                                        })
                                    }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    <Option key={'0'} value={'all'}>
                                        TODAS
                                    </Option>
                                    {this.state.subsidiaries.data.map(g => (
                                        <Option key={g.id} value={g.id}>
                                            {g.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col lg={5}>
                            <Form.Item label="Cajero">
                                <Select
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Selecciona un usuario"
                                    optionFilterProp="children"
                                    value={this.state.users.current}
                                    onChange={value => {
                                        this.setState({
                                            users: {
                                                ...this.state.users,
                                                current: value,
                                            },
                                        })
                                    }}
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    <Option key={'0'} value={'all'}>
                                        TODOS
                                    </Option>
                                    {this.state.users.data.map(g => (
                                        <Option key={g.id} value={g.id}>{`${g.name} ${g.last_name}`}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col lg={2}>
                            <br />
                            <br />
                            <Button disabled={this.state.orders.loading} onClick={this.redirectGetData}>
                                Buscar
                            </Button>
                        </Col>
                        <Col lg={2}>
                            <br />
                            <br />
                            <Button
                                disabled={this.state.orders.loading}
                                onClick={() => {
                                    this.setState(
                                        {
                                            dateRange: {
                                                startDate: null,
                                                endDate: null,
                                            },
                                            orders: {
                                                data: [],
                                                loading: false,
                                            },
                                            users: {
                                                data: [],
                                                loading: false,
                                                current: null,
                                            },
                                            subsidiaries: {
                                                data: [],
                                                loading: false,
                                                current: this.state.localSubsidiary,
                                            },
                                        },
                                        this.redirectGetData
                                    )
                                }}
                            >
                                Limpiar filtros
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Table
                            dataSource={this.state.orders.data}
                            columns={columns}
                            pagination={this.state.pagination}
                            rowKey="uid"
                            onChange={this.handleTableChange}
                            loading={this.state.loading}
                        />
                    </Row>
                </Form>
                <Divider />
            </>
        )
    }
}

const WrappedReportSalesForm = Form.create({ name: 'SalesEntryVerticalForm' })(ReportSalesForm)
export default WrappedReportSalesForm
